import React, { useContext } from 'react';

import { AppType } from '../../../../store/store';
import css from '../SetPlan.module.scss';
import { Plan } from '../index';
import ChoosePlan from '../Plans/ChoosePlan';
import BackButton from '../../../../components/UI/BackButton';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';
import { PlanPrices } from '../../../../utils/prices';

interface Props {
  app: AppType;
  plans: PlanPrices;
  onInfoClicked: (plan: Plan) => void;
  onUpgradeClicked: (plan: Plan) => void;
  onBackClicked: () => void;
  onSkip: () => void;
}

const ChoosePlanContainer = ({
  app,
  plans,
  onSkip,
  onBackClicked,
  onInfoClicked,
  onUpgradeClicked
}: Props) => {
  const { analytics } = useContext(AnalyticsContext);

  return (
    <div className={css.invest} data-e2e="choose-plan">
      <BackButton onClick={onBackClicked} />
      <h1 data-e2e="choose-plan-header">Select a plan</h1>
      <h2 data-e2e="choose-plan-subheader">
        All plans cover the whole family, up to 5 kids. Change plans anytime.
      </h2>
      {['infinity', 'max', 'standard'].map((plan, index) => {
        return (
          <div key={index}>
            <ChoosePlan
              plan={plan}
              plans={plans}
              loading={!!app.loading}
              onSkip={onSkip}
              onInfoClicked={onInfoClicked}
              onUpgradeClicked={onUpgradeClicked}
              analytics={analytics}
            />
          </div>
        );
      })}

      <div className={css.investFooter}>
        <p>
          *See Greenlight's Terms of Service for details on earnings limits and
          how to qualify. Subject to change at any time.
        </p>
        <p>
          **Cell phone and purchase protection provided by Virginia Surety
          Company Inc. Cell phone protection is not available to residents of
          New York.
        </p>
        <p>
          Depending on where you live, you may be charged taxes in addition to
          your subscription price.
        </p>
        <p>
          By choosing to upgrade, you are accepting Greenlight’s{' '}
          <a
            target="_blank"
            href={`https://greenlight.com/terms-of-service`}
            data-e2e="terms"
            rel="noreferrer"
          >
            Terms of Service
          </a>{' '}
          &{' '}
          <a
            target="_blank"
            href={`https://greenlight.com/privacy`}
            data-e2e="privacy-policy"
            rel="noreferrer"
          >
            Privacy Statement
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default ChoosePlanContainer;
